/**
 * Utility to handle and suppress ResizeObserver loop errors
 * 
 * ResizeObserver loop errors occur when multiple resize events happen in rapid succession
 * before the browser can process them all. This is a common issue with React applications
 * that use ResizeObserver, especially with animations or dynamic content.
 * 
 * This utility adds a global error handler that suppresses these specific errors
 * in the console while allowing other errors to be logged normally.
 */

export const initResizeObserverErrorHandler = () => {
  // Store the original error handler
  const originalOnError = window.onerror;

  // Create a new error handler that filters out ResizeObserver loop errors
  window.onerror = function(message, source, lineno, colno, error) {
    // Check if the error is a ResizeObserver loop error
    if (message && message.toString().includes('ResizeObserver loop')) {
      // Suppress the error
      return true; // Prevents the error from being logged in the console
    }

    // For all other errors, call the original handler
    if (typeof originalOnError === 'function') {
      return originalOnError.apply(this, arguments);
    }
    
    // If no original handler, let the error propagate
    return false;
  };
};
